<template>
  <div class="supplier-mes-input card">
    <div class="flex-center">
      <el-form>
        <el-form-item />
      </el-form>
      <!--    竞高价使用-->
      <el-input-number
        v-if="mode == 1"
        v-model="money"
        controls-position="right"
        :min="Number(currentMoney) || Number(startMoney)"
        :step="Number(step)"
        :precision="2"
      />
      <!--    竞低价使用-->
      <el-input-number
        v-if="mode == 0"
        v-model="money"
        controls-position="right"
        :min="0"
        :max="Number(currentMoney) || Number(startMoney)"
        :step="Number(step)"
        :precision="2"
      />
      <el-button
        :type="disabled ? 'info' : 'primary'"
        :disabled="disabled"
        :loading="loading"
        @click="quote"
      >报价</el-button>
    </div>
    <money-in-cn class="m-t-5" :money="money" />
  </div>
</template>

<script>
// 组件
import MoneyInCn from '@/components/common/MoneyInCn'

export default {
  name: 'SupplierMesInput',

  components: { MoneyInCn },

  props: {
    // 1：高价 0：低价
    mode: {
      type: [String, Number],
      require: true
    },
    step: {
      type: [String, Number],
      default: 1
    },
    // 当前的最新报价
    currentMoney: {
      type: [String, Number],
      default: 10
    },
    // 起始价
    startMoney: {
      type: [String, Number],
      require: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    quoteFun: {
      type: Function,
      require: true
    }
  },

  data() {
    return {
      money: ''
    }
  },

  watch: {
    startMoney(val) {
      this.money = Number(val)
    }
  },

  created() {
    this.money = Number(this.startMoney)
  },

  methods: {
    // 更新竞价金额
    // refreshQuoteMoney(val) {
    //   // 竞高价
    //   if (this.mode == 1 && Number(this.money) <= val) {
    //     this.money = val
    //
    //     if (Number(this.currentMoney)) {
    //       this.money = val + Number(this.step)
    //     }
    //   }
    //
    //   // 竞低价
    //   if (this.mode == 0) {
    //     if (Number(this.money) < val && Number(this.money) > 0) return
    //
    //     this.money = val
    //
    //     const temp = val - Number(this.step)
    //
    //     if (Number(this.currentMoney) && temp > 0) {
    //       this.money = temp
    //     }
    //   }
    // },

    // 竞价
    quote() {
      if (!this.money) {
        this.$message.warning('请输入竞价金额')
        return
      }

      if (!/^(([1-9]\d*)|0)(\.\d{0,2})?$/.test(this.money)) {
        this.$message.error('请输入正确的竞价金额')
        return
      }

      if (
        this.mode == 1 &&
        this.money < (Number(this.currentMoney) || Number(this.startMoney))
      ) {
        this.$message.warning('竞高价模式下，竞价金额不能低于当前报价')
        return
      }

      if (
        this.mode == 0 &&
        this.money > (Number(this.currentMoney) || Number(this.startMoney))
      ) {
        this.$message.warning('竞低价模式下，竞价金额不能高于当前报价')
        return
      }

      if (
        this.mode == 0 &&
        Number(this.currentMoney) &&
        this.money > Number(this.currentMoney) - Number(this.step)
      ) {
        this.$message.warning('竞价幅度不能低于' + this.step)
        return
      }

      if (
        this.mode == 1 &&
        this.money < Number(this.currentMoney) + Number(this.step)
      ) {
        this.$message.warning('竞价幅度不能低于' + this.step)
        return
      }

      this.quoteFun && this.quoteFun(this.money)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.supplier-mes-input {
  height: 120px;
  padding: pixel-to-rem($n: 20);
  margin-top: 10px;

  ::v-deep .el-input-number {
    flex: 1;

    .el-input__inner {
      text-align: left;
    }
  }

  ::v-deep .el-button {
    margin-left: pixel-to-rem($n: 30);
  }
}
</style>
